import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import ClearButton from '../filter/clear-button';

export const FeaturedFiltersWrapper = styled.div`
  ${media.mediumDown`
    display: none;
  `}
`;

export const FeaturedFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`;

type FilterWrapperProps = {
  isOpen: boolean;
};

export const FilterWrapper = styled.div<FilterWrapperProps>`
  display: flex;
  position: relative;
  z-index: 10;
`;

export const FeaturedFilterButtonText = styled.span`
  white-space: nowrap;
`;

export const AppliedFiltersWrapper = styled.div`
  margin: ${layout.spacing.xSmall};
`;

export const FilterPopup = styled.div`
  background: ${p => p.theme.bg.primary};
  box-shadow: 2px 2px 8px -1px rgba(0, 0, 0, 0.25);
  margin-top: ${layout.spacing.xSmall};
  width: 360px;
`;

export const FilterContent = styled.div`
  max-height: 400px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const FilterFooter = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${p => p.theme.bg.primary};
  width: 100%;
  padding: ${layout.spacing.small};
`;

export const FilterFooterButtonStyles = css`
  width: 50%;
`;

export const FilterFooterClearButton = styled(ClearButton)`
  ${FilterFooterButtonStyles};
  margin-right: ${layout.spacing.small};
`;

export const FilterFooterApplyButton = styled(Button)`
  ${FilterFooterButtonStyles};
`;
